import {HistoryOutlined} from "@ant-design/icons";
import TransactionsTabs from "./TransactionsTabs";
import TransactionsTable from "./TransactionsTable";

export default function TransactionsCard({
                                           tab, onTabChange, rows, amountIcon, amountClassName, loading = false,
                                         }) {
  return (<section className="pb-10">
      <div className="bg-white rounded-[20px] shadow-lg p-4 md:p-8">
        <div className="flex items-center gap-3 pb-4 md:pb-6 border-b">
          <div
            className="w-9 h-9 md:w-11 md:h-11 rounded-full bg-blue-100 flex items-center justify-center text-[var(--blue-3)]">
            <HistoryOutlined/>
          </div>
          <h2 className="m-0 font-semibold text-[18px] md:text-[22px] text-[#0B1B3A]">
            История транзакций
          </h2>
        </div>

        <div className="pt-4 md:pt-6">
          <TransactionsTabs tab={tab} onTabChange={onTabChange}/>
          <TransactionsTable
            rows={rows}
            amountIcon={amountIcon}
            amountClassName={amountClassName}
            loading={loading}
          />
        </div>
      </div>
    </section>);
}